export const GET_LIST_REQUEST_APPROVAL = '/request_approval/';
export const PUT_REQUEST_APPROVAL = id => `/request_approval/${id}/`;
export const PATCH_REQUEST_APPROVAL = id => `/request_approval/${id}/`;
